import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { openNowSSO } from '@foody/fe-common';
import { trans } from '../../localization/index';
import { getParameterByName, isEmpty, isEmptyObject } from '../../utils/utils';
import { EnumLoginType } from '../../constants/enum';
import { manualLogin, socialLogin } from './actions';
import './login.scss';
import GoogleLogin from './Components/GoogleLogin';
import { VERIFIED_OTP } from '../../constants/constants';

import EmailIcon from '../../assets/common/images/icon/email.png'
import PasswordIcon from '../../assets/common/images/icon/password.png'

class Login extends React.Component {
  state = {
    account: '',
    password: '',
    errorMessage: '',
    rememberMe: true,
    isShowUsername: false,
  };

  componentWillMount() {
    const { location, authenticated, history } = this.props;
    if (authenticated) {
      if (!isEmptyObject(location.state)) {
        const { from } = location.state;
        const { pathname } = from;
        if (pathname !== '/account/login') {
          history.push(from);
        }
      } else {
        history.push({
          pathname: '/',
          state: {
            from: location.pathname,
          },
        });
      }
    } else {
      const hash = location.hash.slice(1);
      const tokenId = getParameterByName('id_token', `?${hash}`);
      if (hash.length > 0 && !isEmpty(tokenId)) {
        this.handleSocialLogin(tokenId, EnumLoginType.GOOGLE.id);
      }
      if (location.state && location.state.account) {
        this.setState({
          account: location.state.account,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { location, authenticated, history } = nextProps;

    const hash = location.hash.slice(1);
    const state = getParameterByName('state', `?${hash}`);
    if (authenticated) {
      if (!isEmptyObject(location.state)) {
        const { from } = location.state;
        if (from !== '/account/login') {
          history.push(from);
        }
      } else if (state) {
        history.push(state);
      } else {
        history.push({
          pathname: '/',
          state: {
            from: location.pathname,
          },
        });
      }
    }
  }

  handleSocialLogin = (tokenId, type) => {
    const { socialLoginConnect } = this.props;
    if (tokenId) {
      socialLoginConnect(tokenId, type);
    }
  };

  handleSubmitLogin = () => {
    const { account, password } = this.state;
    if (isEmpty(account)) {
      this.setState({
        errorMessage: trans('missing_username'),
      });
    } else if (isEmpty(password)) {
      this.setState({
        errorMessage: trans('missing_password'),
      });
    } else {
      const callbackFailAction = errorMessage => {
        this.setState({
          errorMessage,
        });
      };

      const { manualLoginConnect } = this.props;
      manualLoginConnect(account, password, callbackFailAction);
    }
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.handleSubmitLogin();
    }
  };

  handleReceiveOTPSuccess = data => {
    const { auth_code: authCode } = data;
    this.handleSocialLogin(authCode, EnumLoginType.ACCOUNT_KIT.id);
  };

  handleOpenOTP = () => {
    openNowSSO({ successCallback: this.handleReceiveOTPSuccess });
  };

  render() {
    const {
      account,
      password,
      errorMessage,
      rememberMe,
      isShowUsername,
    } = this.state;
    const { location } = this.props;
    const redirectUri = location.state ? location.state.from.pathname : '/';
    const verifiedOtp = new URLSearchParams(location.search).get('verifiedOtp');
    return (
      <div className="now-login">
        <div className="content w-420">
          <div className="title">{trans('login_system')}</div>
          <div className="login-via">
            <button
              className="btn btn-submit"
              onClick={this.handleOpenOTP}
            >
              {trans('login_otp')}
            </button>
          </div>
          <div className="login-via">
            <GoogleLogin
              clientId={CONFIG.GOOGLE_LOGIN_CLIENT_ID}
              scope="email profile openid"
              state={redirectUri}
              redirectUri={`${window.location.origin}/account/login`}
            />
          </div>
          {verifiedOtp !== VERIFIED_OTP &&
            (!isShowUsername ? (
              <button
                className="btn login-username-btn"
                onClick={() => this.setState({ isShowUsername: true })}
              >
                {trans('login_with_username')}
              </button>
            ) : (
              <React.Fragment>
                &nbsp;
                <p className="text">
                  {trans('account_or_sign_in_with_your_account')}
                </p>
                {errorMessage && (
                  <div className="alert-danger">{errorMessage}</div>
                )}
                <div className="form-login-input">
                  <div className="field-group">
                    <div className="input-group">
                      {/* <i className="far fa-envelope" /> */}
                      <img className="far fa-envelope" src={EmailIcon} alt="email icon" />
                      <input
                        type="text"
                        placeholder="Username or email"
                        value={account}
                        onChange={event => {
                          this.setState({
                            account: event.target.value,
                            errorMessage: '',
                          });
                        }}
                      />
                    </div>
                    <div className="input-group">
                      {/* <i className="fas fa-lock" /> */}
                      <img className="fas fa-lock" src={PasswordIcon} alt="password icon" />
                      <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onKeyPress={this.handleKeyPress}
                        onChange={event => {
                          this.setState({
                            password: event.target.value,
                            errorMessage: '',
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <input
                      type="checkbox"
                      id="RememberMe"
                      checked={rememberMe}
                      onChange={() => {
                          this.setState({ rememberMe: !rememberMe });
                        }}
                    />
                    <label htmlFor="RememberMe">
                      {trans('account_save_login')}
                    </label>
                    <span>
                      <Link to="/account/forgot-password">
                        {trans('account_forgot_password')}
                      </Link>
                    </span>
                  </div>
                  <button
                    className="btn btn-submit btn-login-with-username"
                    onClick={this.handleSubmitLogin}
                  >
                    {trans('login')}
                  </button>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.auth.authenticated,
  auth: state.auth,
  errorMessage: state.login.errorMessage,
});

const mapDispatchToProps = {
  socialLoginConnect: socialLogin,
  manualLoginConnect: manualLogin,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Login),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Login/Login.jsx